<dx-popup title="Delete"
          [(visible)]="visible"
          [animation]="animation"
          hideOnOutsideClick="true"
          [dragEnabled]="false"
          [shadingColor]="shadingColor"
          [height]="showProductAssociations ? 'auto' : showVehicleDeleteMsg || showDataAreaDeleteMsg ? 'auto' : 'auto'"
          [maxWidth]="showVehicleDeleteMsg || showDataAreaDeleteMsg || showProductAssociations ? 600 : maxWidth"
          (onHidden)="cancel()">
  <div>
    <div>
      <div  *ngIf="showVehicleDeleteMsg">
        <b>Attention</b>: {{attentionMsg}}
        <br/>
        <br/>
        Do you still want to delete this {{entityName}}?
      </div>
      
      <div *ngIf="showProductAssociations && productAssociations">
        <p><strong>This product is associated with the following:</strong></p>
        <ul style="list-style-type: disc; padding-left: 20px; margin-left: 20px;">
          <li *ngIf="productAssociations.ProductGroupCount > 0">
            ({{productAssociations.ProductGroupCount}}) Product Group(s)
          </li>
          <li *ngIf="productAssociations.ProductTransformationCount > 0">
            ({{productAssociations.ProductTransformationCount}}) Product Transformation(s)
          </li>
          <li *ngIf="productAssociations.BlendCount > 0">
            ({{productAssociations.BlendCount}}) Blend(s)
          </li>
          <li *ngIf="productAssociations.DeviceMappingCount > 0">
            ({{productAssociations.DeviceMappingCount}}) Register Product Mapping(s)
          </li>
        </ul>
        <p style="margin-top: 15px; margin-bottom: 20px;"><strong>Deleting this product will also remove all associated entries. Are you sure you want to continue?</strong></p>
      </div>
      
      <div *ngIf="!showVehicleDeleteMsg && !showDataAreaDeleteMsg && !showProductAssociations">
        Are you sure you want to delete this {{entityName}}?
      </div>
      <div  *ngIf="showDataAreaDeleteMsg">
        {{message}}
      </div>
    </div>
    <div class="row text-center pt-3 pb-3">
      <div class="col">
        <button (click)="confirm()"
                id="action-confirm-delete">
          <img src="assets/Content/Images/Icons/delete.png"
               class="edit-button-image" />
          <span class="edit-button d-none d-xl-inline-block">Delete</span>
        </button>
      </div>
      <div class="col">
        <button (click)="cancel()"
                id="action-confirm-cancel">
          <img src="assets/Content/Images/Icons/cancel.png"
               class="edit-button-image" />
          <span class="edit-button d-none d-xl-inline-block">Cancel</span>
        </button>
      </div>
    </div>
  </div>
</dx-popup>